import React from 'react';

import { Card, CardBody, CardDescription, CardHeader, CardHeaderAction, CardHeaderText, CardTitle } from './styles';

interface SectionCardProps {
  title: string;
  description: string;
  action?: React.ReactNode;
  collapsed?: boolean;
  children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ title, description, action, collapsed = false, children }) => (
  <Card>
    <CardHeader>
      <CardHeaderText>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeaderText>
      {action && <CardHeaderAction>{action}</CardHeaderAction>}
    </CardHeader>
    {!collapsed && <CardBody>{children}</CardBody>}
  </Card>
);

export default SectionCard;
